import flatpickr from "flatpickr";
import axios from 'axios';
import deliveryDate from '../components/delivery-date';

export default function cartPage() {
    jQuery( document.body ).on('updated_cart_totals', function( event ) {
        deliveryDate();
    } );

    deliveryDate();

    let check_delivery_btn = document.querySelector('.check_delivery');

    if (check_delivery_btn) {
        check_delivery_btn.addEventListener('click', function (e) {
            e.preventDefault();
            checkDelivery();
        });
    }

    var couponeCodeToggle = document.getElementById('toggleCouponCode');
    var couponCodeContainer = document.getElementById('couponCodeContainer');
    couponeCodeToggle.addEventListener('click', (e) => {
        e.preventDefault();
        if(couponCodeContainer.classList.contains('open')) {
            couponCodeContainer.style.maxHeight = '0';
            couponCodeContainer.classList.remove('open');
        } else {
            couponCodeContainer.style.maxHeight = '110px';
            couponCodeContainer.classList.add('open');
        }
        return false;
    });

    var quantityChanging;

    // global change event, as quantity field gets reloaded via ajax
    document.addEventListener('change', (e) => {
        // quantity update
        if (e.target.classList.contains('qty')) {
            clearTimeout(quantityChanging);
            quantityChanging = setTimeout(() => {
                document.querySelector('button[name=update_cart]').click();
            }, 500)
        }
        //postcode or delivery date update
        if(e.target.classList.contains('delivery-postcode') || e.target.classList.contains('delivery-date')) {
            checkDelivery();
        }
    });

    function checkDelivery() {
        let delivery_date = document.querySelector('.delivery-date').value;
        let delivery_postcode = document.querySelector('.delivery-postcode').value;

        let formData = new FormData();
        formData.append('delivery_date', delivery_date);
        formData.append('delivery_postcode', delivery_postcode);

        axios.post(themosis.ajaxurl + '?action=delivery-check', formData, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            console.log(response.data);
            location.reload();
        }).catch(function (error) {
            console.log(error);
        });
    }

}